module.exports = __webpack_public_path__ + "img/warning_login.ad68db13.svg";